import styled from "styled-components";
import { SearcherItem } from "../../../searcher/styled.js";
export const SearcherItemDestination = styled(SearcherItem).withConfig({
    displayName: "styled__SearcherItemDestination",
    componentId: "sc-f388a66f-0"
})`
	--searcher-item-xl-basis: 40%;

	${({ theme  })=>theme.media.between('md', 'lg')} {
		flex-basis: 100%;
		max-width: 100%;
	}

	${({ theme  })=>theme.media.between('lg', 'xl')} {
		--searcher-item-lg-width: calc((100% - 150px - var(--division-gap)) / 3 - var(--division-gap) * 2 / 3);
		flex-basis: var(--searcher-item-lg-width);
		max-width: var(--searcher-item-lg-width);
	}
`;
export const SearcherItemCalendar = styled(SearcherItem).withConfig({
    displayName: "styled__SearcherItemCalendar",
    componentId: "sc-f388a66f-1"
})`
	--searcher-item-xl-basis: 20%;

	${({ theme  })=>theme.media.between('md', 'lg')} {
		--searcher-item-md-width: calc((100% - 120px - var(--division-gap)) / 2 - var(--division-gap) / 2);
		flex-basis: var(--searcher-item-md-width);
		max-width: var(--searcher-item-md-width);
	}

	${({ theme  })=>theme.media.between('lg', 'xl')} {
		--searcher-item-lg-width: calc((100% - 150px - var(--division-gap)) / 3 - var(--division-gap) * 2 / 3);
		flex-basis: var(--searcher-item-lg-width);
		max-width: var(--searcher-item-lg-width);
	}
`;
export const SearcherItemAccommodation = styled(SearcherItem).withConfig({
    displayName: "styled__SearcherItemAccommodation",
    componentId: "sc-f388a66f-2"
})`
	--searcher-item-xl-basis: 20%;

	${({ theme  })=>theme.media.between('md', 'lg')} {
		--searcher-item-md-width: calc((100% - 120px - var(--division-gap)) / 2 - var(--division-gap) / 2);
		flex-basis: var(--searcher-item-md-width);
		max-width: var(--searcher-item-md-width);
	}

	${({ theme  })=>theme.media.between('lg', 'xl')} {
		--searcher-item-lg-width: calc((100% - 150px - var(--division-gap)) / 3 - var(--division-gap) * 2 / 3);
		flex-basis: var(--searcher-item-lg-width);
		max-width: var(--searcher-item-lg-width);
	}
`;

//# sourceMappingURL=styled.js.map